export function retry<T = unknown>(
	fn: () => Promise<T>,
	retriesLeft = 5,
	interval = 1000,
) {
	return new Promise<T>((resolve, reject) => {
		fn().then(resolve, (error) => {
			console.log('retrying...')
			setTimeout(() => {
				if (retriesLeft === 0) {
					reject(error)
					return
				}

				// Passing on "reject" is the important part
				retry(fn, retriesLeft - 1, interval).then(resolve, reject)
			}, interval)
		})
	})
}
